export const errorDomaniNotValid = "Il dominio non è valido";
export const errorMessaggeAi = "Qualcosa è andato storto";
export const erroreCampoObbligatorio = "Il campo è obbligatorio";
export const erroreCaratteriNonValidi = "Caratteri non validi";
export const erroreFormato = "Formato non valido";
export const erroreFormatoEmail = "Formato email non valido";
export const errorEmailAlreadyRegistered = "Questa email è già registrata";
export const errorEmailAlreadyUsed = "Email già in uso";
export const errorEmailNotExist =
  "L'email che hai inserito non è associata ad alcun account";
export const errorFileAlreadyPresent =
  "Questo file è già presente in piattaforma";
export const errorFileIdNotPresent = "FileId non presente a db";
export const errorFileLimitMax =
  "Il file supera la dimensione massima di 150 Mb";
export const errorFileNotSupported = "Questo file non è supportato";
export const errorFileRequired = "Il File è obbligatorio";
export const errorGeneric = "Errore generico";
export const errorISBN = "L’ISBN è già presente in archivio";
export const errorISBNFormat =
  "Formato errato. Deve essere 13 caratteri solo numerici";
export const errorLabel = "Errore";
export const errorMaxLength = "Massimo numero di caratteri ";
export const errorOccurred = "Si è verificato un errore";
export const errorPassword = "La password inserita è errata";
export const errorPasswordNotMatching = "Le password non corrispondono";
export const errorPermission =
  "Non hai i permessi per effettuare questa azione";
export const errorProjectNotFound = "Progetto non trovato";
export const errorSourceName = "Il nome è già presente in archivio";
export const errorSourceTitleName = "Il titolo è già presente in archivio";
export const errorTopicName = "Il nome è già presente in piattaforma";
